import { render, staticRenderFns } from "./Tldr.vue?vue&type=template&id=be8f2e30"
import script from "./Tldr.vue?vue&type=script&lang=js"
export * from "./Tldr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports